// extracted by mini-css-extract-plugin
export var block = "style-module--block--73fab";
export var container = "style-module--container--5b9e5";
export var revs = "style-module--revs--e8839";